module.exports = __webpack_public_path__ + "img/logo.7e65ec83.svg";